// noinspection JSUnusedGlobalSymbols

import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { DialogHelper } from "../../core/util/dialogHelper";
import { PlanningBoardLookupHelper } from "./editPlanningBoardLookup";
import React from "react";
export default class LookupsGrid extends React.Component<any, {gridData: any[]}> {
    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Config.translations.newLabel,
            type: ToolBarStandardButtonType.NEW,
            enabled: true
        },
        {
            caption: Config.translations.editLabel,
            type: ToolBarStandardButtonType.EDIT,
            enabled: true
        },
        {
            caption: Config.translations.deleteLabel,
            type: ToolBarStandardButtonType.DELETE,
            enabled: true
        }
    ];
    constructor(props) {
        super(props)
        this.state = {
            gridData: []
        }
        this.loadGridData().then(() => {});
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass>("PlanningBoardLookup/GetAll");
        this.setState({ gridData: result.Data })
    } 


    private renderGrid = () => {
        return (
            <div className="flex-container" style={{ height: "350px" }}>
                <Grid
                    data={this.state.gridData}
                    options={this.props.field.gridOptions}
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onButtonClick}
                    id="GeneralSettings_PlanningBoardLookups_Grid"
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, dataItem: { Id: string }) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                await PlanningBoardLookupHelper.newTemplate();
                await this.loadGridData();
                break;
            case ToolBarStandardButtonType.EDIT:
                await PlanningBoardLookupHelper.editTemplate(dataItem.Id);
                await this.loadGridData();
                break;
            case ToolBarStandardButtonType.DELETE:
                const ok = await DialogHelper.confirm(__internal_translations["Standard.Msg.Loeschen"]);
                if (ok) {
                    await PlanningBoardLookupHelper.delete(dataItem.Id)
                    await this.loadGridData();
                }
                break;
        }

    }

    render() {
        return this.renderGrid();
    }
}